module.exports = __webpack_public_path__ + "static/img/SketchPngf0cd179c3ad6c868b4a6030492dfe52ee36bf542d3c78403aecb7c8d94e90616.e94aaf8b.png";